function setUpTabNavigation(sectionId) {
  const rootEl = document.querySelector(sectionId);
  if (!rootEl) return;

  const tabList = rootEl.querySelector('[role="tablist"]');
  if (!tabList) return;

  const tabs = tabList.querySelectorAll(':scope > [role="tab"]');
  let activeTab = null;

  const heading = rootEl.querySelector(
    '.plp-header-categories-heading .font-primary.legal',
  );
  const defaultDesc = heading ? heading.textContent.trim() : '';
  let isLocked = false;

  syncFromUrl();

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      if (isLocked) return;
      isLocked = true;
      tab.classList.add('is-loading');

      const isSelected = tab.getAttribute('aria-selected') === 'true';

      if (isSelected) {
        // Reset
        tab.setAttribute('aria-selected', 'false');
        rootEl
          .querySelector(`#${tab.getAttribute('aria-controls')}`)
          .setAttribute('hidden', true);
        activeTab = null;
        if (heading) {
          heading.textContent = defaultDesc;
        }
        resetNostoFilter();
      } else {
        // remove old tab
        if (activeTab) {
          activeTab.setAttribute('aria-selected', 'false');
          rootEl
            .querySelector(`#${activeTab.getAttribute('aria-controls')}`)
            .setAttribute('hidden', true);
        }

        // select new tab
        tab.setAttribute('aria-selected', 'true');
        rootEl
          .querySelector(`#${tab.getAttribute('aria-controls')}`)
          .removeAttribute('hidden');
        activeTab = tab;

        // Update description
        const tabpanel = rootEl.querySelector(
          `#${tab.getAttribute('aria-controls')}`,
        );
        const desc = tabpanel.querySelector(
          '.plp-header-categories-tabpanel-details-list',
        );

        if (heading) {
          heading.textContent = desc ? desc.textContent.trim() : defaultDesc;
        }

        // Trigger filter
        triggerNostoFilter(tab.textContent.trim());
      }

      setTimeout(() => {
        isLocked = false;
        tab.classList.remove('is-loading');
      }, 3000);
    });
  });

  function triggerNostoFilter(label) {
    // target filter text
    const targetText = `Allday ${label}`;
    const options = document.querySelectorAll('.facet-checkbox__text.nosto');

    options.forEach((el) => {
      const text = el.textContent.trim();
      const checkbox = el.closest('label')?.querySelector('input');
      if (text.startsWith('Allday ') && checkbox && checkbox.checked) {
        el.click();
      }
    });

    // Tick filter after 1s
    setTimeout(() => {
      options.forEach((el) => {
        const text = el.textContent.trim();
        const checkbox = el.closest('label')?.querySelector('input');
        if (text === targetText && checkbox && !checkbox.checked) {
          el.click();
        }
      });
    }, 1000);
  }

  function resetNostoFilter() {
    const options = document.querySelectorAll('.facet-checkbox__text.nosto');
    options.forEach((el) => {
      const text = el.textContent.trim();
      if (text.startsWith('Allday ')) {
        const checkbox = el.closest('label')?.querySelector('input');
        if (checkbox && checkbox.checked) {
          el.click();
        }
      }
    });
  }

  function activateTab(tab) {
    if (activeTab) {
      activeTab.setAttribute('aria-selected', 'false');
      rootEl
        .querySelector(`#${activeTab.getAttribute('aria-controls')}`)
        .setAttribute('hidden', true);
    }

    tab.setAttribute('aria-selected', 'true');
    rootEl
      .querySelector(`#${tab.getAttribute('aria-controls')}`)
      .removeAttribute('hidden');
    activeTab = tab;

    // Update description
    const tabpanel = rootEl.querySelector(
      `#${tab.getAttribute('aria-controls')}`,
    );
    const desc = tabpanel.querySelector(
      '.plp-header-categories-tabpanel-details-list',
    );
    if (desc && heading) {
      heading.textContent = desc.textContent.trim();
    }

    // Trigger filter
    triggerNostoFilter(tab.textContent.trim());
  }

  function syncFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const filterParam = params.get('filter.customFields.filter-style');
    if (!filterParam) return;

    const values = filterParam.split('||');
    const first = values[0].trim();

    if (first.startsWith('Allday ')) {
      const label = first.replace('Allday ', '');

      tabs.forEach((tab) => {
        if (tab.textContent.trim().toLowerCase() === label.toLowerCase()) {
          activateTab(tab);
        }
      });
    }
  }
}
